import { render, staticRenderFns } from "./DoKoAvatar.vue?vue&type=template&id=4b49c444&"
import script from "./DoKoAvatar.vue?vue&type=script&lang=ts&"
export * from "./DoKoAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports